// src/components/HeroSection.tsx
import { Button, Row, Col, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const HeroSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="hero-section">
      <div className="hero-content">
        <Row align="middle" justify="center" gutter={[48, 32]}>
          <Col xs={24} lg={20} xl={18}>
            <div className="hero-text">
              <Title level={1} className="hero-title">
                {t('hero.title')}
              </Title>
              <Title level={2} className="hero-subtitle">
                {t('hero.subtitle')}
              </Title>
              <Paragraph className="hero-description">
                {t('hero.description')}
              </Paragraph>
              <div className="hero-buttons">
                <Button size="large" className="secondary-btn" onClick={() => navigate('/contact')}>
                  {t('hero.learnMore')}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default HeroSection;
